var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26953 9.74994C5.26829 8.86045 5.44311 7.97951 5.78392 7.1579C6.12473 6.33628 6.62478 5.59025 7.25526 4.9628C7.88574 4.33535 8.63417 3.83889 9.45741 3.50204C10.2807 3.16519 11.1624 2.99461 12.0519 3.00013C15.7634 3.02772 18.7322 6.11275 18.7322 9.83468V10.4999C18.7322 13.8577 19.4347 15.8061 20.0534 16.871C20.1201 16.9848 20.1555 17.1142 20.1562 17.246C20.157 17.3779 20.1229 17.5076 20.0574 17.6221C19.992 17.7366 19.8975 17.8318 19.7836 17.8982C19.6696 17.9645 19.5401 17.9996 19.4083 17.9999H4.59271C4.46082 17.9996 4.33136 17.9645 4.21738 17.8981C4.10339 17.8318 4.00892 17.7366 3.9435 17.622C3.87808 17.5075 3.84401 17.3778 3.84474 17.2459C3.84547 17.114 3.88096 16.9846 3.94765 16.8709C4.56671 15.8059 5.26952 13.8575 5.26952 10.4999L5.26953 9.74994Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18V18.75C9 19.5456 9.31607 20.3087 9.87868 20.8713C10.4413 21.4339 11.2044 21.75 12 21.75C12.7956 21.75 13.5587 21.4339 14.1213 20.8713C14.6839 20.3087 15 19.5456 15 18.75V18",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.c876b32793f40f7b375d38b6fd669758.svg";
export { ForwardRef as ReactComponent };